import React from "react";
import PropTypes from "prop-types";
import { Message } from "@qgiv/core-donor";
import * as messageLocations from "./constants/messageLocations";

const AccountFormMessage = ({ submittedMessage }) => {
    // If the submitted message has keys then there is a message as a result of
    // the submission of the account form
    const hasSubmittedMessage = Object.keys(submittedMessage).length > 0;

    // Confirm that there is a message
    if (hasSubmittedMessage) {
        const { location, message, type } = submittedMessage;
        const messageProp = {
            type,
            message,
        };

        // And render the message it if it was intended for the account form
        if (location === messageLocations.ACCOUNT_FORM) {
            return (
                <div className="grid">
                    <div className="col col--12">
                        <Message message={messageProp} />
                    </div>
                </div>
            );
        }
    }

    return null;
};

AccountFormMessage.propTypes = {
    submittedMessage: PropTypes.shape({
        location: PropTypes.string,
        message: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.string,
    }).isRequired,
};

export default AccountFormMessage;
